// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"TemplatesListPage_contentComponent__3-pMG","tableContainer":"TemplatesListPage_tableContainer__3VGqO"};